<template>
  <form
    class="modal-content"
    @submit.prevent="submit"
  >
    <div class="modal-content__wrapper">
      <h3 class="modal-title">{{ title }}</h3>
      <p class="modal-text">{{ text }}</p>

      <div
        v-for="field in modalData"
        :key="field.name"
        class="form-group"
      >
        <label
          v-if="field.title"
          class="form-label"
          :for="field.name"
        >
          {{ field.title }}
        </label>

        <select
          v-if="field.type === 'select'"
          v-model="form[field.name]"
          :id="field.name"
          class="form-input"
        >
          <option
            value="-1"
            disabled
          >
            {{ field.placeholder }}
          </option>

          <option
            v-for="(fieldOption, index) in field.values"
            :key="`${fieldOption[field.itemValue]}-${index}`"
            :value="fieldOption[field.itemValue]"
          >
            {{ fieldOption[field.itemText] }}
          </option>
        </select>

        <textarea
          v-else-if="field.type === 'textarea'"
          :id="field.name"
          v-model="form[field.name]"
          :placeholder="field.placeholder"
          class="form-input"
        />

        <input
          v-else
          :id="field.name"
          v-model="form[field.name]"
          :min="field.min"
          :max="field.max"
          :hidden="field.hidden"
          :placeholder="field.placeholder"
          class="form-input"
          :type="field.type"
          @input="validateInput($event, field)"
        />
      </div>

      <div
        v-if="error"
        class="modal-error"
      >
        {{ error }}
      </div>
    </div>

    <div class="modal-actions">
      <button
        type="button"
        class="modal-button modal-button--cancel"
        @click="closeModal(null)"
      >
        {{ textCancelBtn }}
      </button>

      <button
        type="submit"
        class="modal-button modal-button--confirm"
        :disabled="canCreate"
      >
        {{ textConfirmBtn }}
      </button>
    </div>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import moment from "moment";

export default {
  name: 'CreateBase',
  props: {
    name: {
      type: String,
      default: ''
    },   
    moduleAction: {
      type: String,
      default: ''
    },  
    type: {
      type: String,
      default: ''
    },  
    title: {
      type: String,
      default: ''
    },   
    text: {
      type: String,
      default: ''
    },  
    textCancelBtn: {
      type: String,
      default: ''
    },  
    textConfirmBtn: {
      type: String,
      default: ''
    },
    onClose: {
      type: Function,
      default: null
    },
    data: {
      type: Object,
      default: () => ({})
    },
    callback: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      form: {},
      modalData: null,
      isSubmitting: false,
      error: null
    }
  },
  computed: {
    canCreate () {
      return this.modalData
        && Object.entries(this.modalData).some(([, value]) => value?.required && (!this.form[value.name] || this.form[value.name] === -1))
        || this.isSubmitting
    }
  },
  mounted () {
    this.seedForm()
  },
  beforeDestroy () {
    if (typeof this.onClose === 'function') {
      this.onClose()
    }
  },
  methods: {
    ...mapActions('modal', ['closeModal']),
    ...mapActions('settings', ['loadModalData']),
    validateInput (evt, { min, max } = {}) {
      if (min || max) {
        const { value } = evt.target

        if (Number(value) < Number(min)) {
          this.error = `Минимальное значение ${min}`

          return
        }

        if (Number(value) > Number(max)) {
          this.error = `Максимальное значение ${max}`

          return
        }

        this.error = null
      }
    },
    async seedForm () {
      this.$bus.emit('start-loader')

      const { data, error } = await this.loadModalData({
        name: this.name,
        type: this.type
      })

      if (error) {
        this.$notify({
          type: 'error',
          title: 'Ошибка при загрузке данных!',
          text: 'Произошла ошибка при загрузке полей для модального окна!',
          clean: false,
          duration: 3000
        })

        this.$bus.emit('stop-loader')

        await this.closeModal(null)
      }

      this.modalData = data
      this.modalData.forEach(({ name, defaultValue }) => {
        const value = Object.prototype.hasOwnProperty.call(this.data, name)
          ? this.data[name]
          : defaultValue

        this.$set(this.form, name, value)
      })

      this.$bus.emit('stop-loader')
    },
    async submit () {
      if (this.error) {
        return
      }

      this.isSubmitting = true

      if (this.form?.dateOfBirth) {
        this.form.dateOfBirth = moment(this.form.dateOfBirth).format('DD.MM.YYYY')
        this.form.role = [this.form.role] // добавить выбор роли как селект
      }

      const { error } = typeof this.callback !== 'function'
        ? await this.$store.dispatch(`${this.moduleAction}/create`, this.form)
        : await this.callback(this.form)

      this.isSubmitting = false

      if (error) {
        this.error = `Произошла ошибка: ${error.message}`

        return
      }

      this.$notify({
        type: 'success',
        title: 'Успех!',
        text: 'Операция успешно выполнена!',
        clean: false,
        duration: 3000
      })

      await this.closeModal(null)
    }
  }
}
</script>

<style lang="scss" src="./style.scss" scoped />
